import { useMemo } from 'react';
import { environmentSvc } from '../../environment.service';
import { peuAssets } from './peu-assets';

export const useAsset = (assetKey: keyof typeof peuAssets) =>
  useMemo(() => environmentSvc.toAbsoluteUrl(peuAssets[assetKey]), [peuAssets[assetKey]]);
